export default __webpack_public_path__ + "static/media/DNo.35-0.83257ab4.jpg";